<template>
<div class="fill flex column flex-fill">

<div class="opt r">

    <input-field  v-show="tab == 'Cuenta de Gastos'"
    v-model="search"
    inputClass="secondary"
    pre="search"
    cleareable
    placeholder="Buscar..."
    :icon="mobile ? 'search' : ''"
    useHeader
    :timeout="300">
    </input-field>

    <input-range ref="range" class="flex-fill" v-show="tab=='Resumen'"
    inputClass="secondary"
    v-model="range"
    @OnValueChanged="Search()"
    :icon="mobile ? 'datetime' : ''">
    </input-range>

    <input-range ref="range" class="flex-fill ml5" v-show="tab == 'Cuenta de Gastos'"
    inputClass="secondary"
    v-model="rangeExpenses"
    @OnValueChanged="LoadExpenses()"
    :icon="mobile ? 'datetime' : ''">
    </input-range>

    <input-date :icon="mobile ? 'calendar' : null" 
        slot="options"
        v-show="tab=='Historial'"
        inputClass="secondary" 
        type="DATE"
        format="timestamp"
        v-model="dateFilter"
        modalOnly
        :toEndDay="true"
        @OnAcceptDate="LoadHistory()">
    </input-date>

    <input-field  v-if="tab == 'Proveedores'" class="ml5"
    v-model="searchProvider"
    placeholder="Buscar..."
    pre="search"
    clearable
    inputClass="secondary"
    :icon="mobile ? 'search' : ''"
    useHeader>
    </input-field>
    <i v-show="isAdmin && tab=='Resumen'" class="options icon-dots-vertical" @click="Options([
        {text: 'Exportar', class: 'selected-color', function: () => { Export() }, icon: 'download'}
    ])"></i>

    <i class="options icon-dots-vertical ml5" v-if="canCreateProvider" @click="Options([
        {text: 'Exportar Proveedores', class: 'selected-color', function: () => {$refs.providerList.ExportProviders()}, icon: 'download'},
        {text: 'Crear Proveedor', class: 'selected-color', function: () => {$refs.providerList.modalProvider={has_rut:true}}, if: canCreateProvider, icon: 'plus'},
    ])"
    v-show="tab=='Proveedores'"></i>
    <i v-show="isAdmin && tab=='Cuenta de Gastos'" class="options icon-dots-vertical" @click="Options([
        {text: 'Configurar Cuenta de Gasto', class: 'selected-color', function: () => {modalNew={expense: {}}}, icon: 'plus'}
    ])"></i>
</div>

<tabs v-model="tab"  v-if="tabs"
:tabs="tabs" :keyByTab="true" 
:tabCount="tabCount" tabCountOnSelectedOnly
@OnTabResumen="stats == null ? Search() : null"
@OnTabHistorial="history.length == 0 ? LoadHistory() : null" class="fill"
@OnTabCuentas="expenses.length == 0 ? LoadExpenses() : null"
@OnTabProveedores="$refs.providerList.providers.length == 0 ? LoadProviders() : null"
>

    <div slot="Resumen" class="pa-body">
        <div v-if="stats && stats.history.length > 0">

            <div class="section mb20" v-if="stats.history.length > 1">
                <chart
                type="line"
                :data="[stats.history]"
                dataset="total_money"
                label="data"
                height="200px"
                :yLabelFormat="(value) => {return Util.Price(value, true)}"
                :tooltip="(value, label, index) => {return `${Util.Price(value)}`}"
                :customColor="[Util.Chart.purpleGradient]">
                </chart>
            </div>

            <!--
            <div class="hs mb20">
                <div>
                    <div class="section flex align-center">
                        <avatar class="mr10"
                        icon="receipt"
                        :color="Util.baseColors.yellow">
                        </avatar>
                        <div class="bold flex-fill">Transacciones</div>
                        <div class="f18 cyellow">{{Util.Number(stats.count)}}</div>
                    </div>
                </div>

                <div>
                    <div class="section flex align-center">
                        <avatar class="mr10"
                        icon="money"
                        :color="Util.baseColors.red">
                        </avatar>
                        <div class="flex-fill">
                            <div class="bold">Total</div>
                        </div>
                        <div class="f18 cred">{{Util.Price(stats.total_money)}}</div>
                    </div>
                </div>
            </div>
            -->

            
            <div class="section flex align-center mb20">
                <avatar class="mr10"
                icon="money"
                :color="Util.baseColors.red">
                </avatar>
                <div class="flex-fill">
                    <div class="bold">Total</div>
                    <div class="secondary-text">{{Util.Number(stats.count)}} transacciones</div>
                </div>
                <div class="f18 cred">{{Util.Price(stats.total_money)}}</div>
            </div>
            

            
            <div class="" v-if="stats.history.length > 1">
                <!--<div class="f18 mb20">Total</div>-->
                <div class="section mb10 selectable"
                @click="history.transactions ? $refs.transactionExpenseList.Open(history.transactions) : null"
                v-for="(history, index) in stats.history"
                :key="index">
                    <div class="flex fill align-center">
                        <div class="flex column flex-fill">
                            <div class="bold">{{history.data}}</div>
                            <div class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(history.count)}}</div>
                        </div>
                        <div class="bold">{{Util.Price(history.total_money)}}</div>
                    </div>
                </div>
            </div>
            

            <div class="mt20" v-if="stats.types.length">
                <div class="f18 mb20">Total por Cuentas de Gastos</div>
                <div class="section mb10 selectable"
                v-for="(type, index) in stats.types"
                :key="index"
                @click="type.transactions ? $refs.transactionExpenseList.Open(type.transactions) : null"
                >
                    <div class="flex fill align-center">
                        <avatar class="mr10"
                        defaultImageIcon="1727"
                        :imageIcon="type.data">
                        </avatar>
                        <div class="flex column flex-fill">
                            <div class="bold">{{type.data}}</div>
                            <div class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(type.count)}}</div>
                        </div>
                        <div class="bold">{{Util.Price(type.total_money)}}</div>
                    </div>
                </div>
            </div>

            <div class="mt20" v-if="stats.categories && Object.keys(stats.categories).length">
                <div class="f18 mb20">Total por Categoría</div>
                <div class="section mb10 selectable"
                v-for="(category, index) in stats.categories"
                :key="index"
                @click="category.transactions ? $refs.transactionExpenseList.Open(category.transactions) : null"
                >
                    <div class="flex fill align-center">
                        <avatar class="mr10"
                        defaultImageIcon="1727"
                        :imageIcon="category.data">
                        </avatar>
                        <div class="flex column flex-fill">
                            <div class="bold">{{DictCategories[category.data]? DictCategories[category.data] : (category.data == null || category.data == '' ? 'Sin categoría' : category.data)}}</div>
                            <div class="secondary-text"><span class="bold">Transacciones: </span>{{Util.Number(category.count)}}</div>
                        </div>
                        <div class="bold">{{Util.Price(category.total_money)}}</div>
                    </div>
                </div>
            </div>
            
        </div>
        <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
    </div>

    <vertical-content ref="verticalHistory" slot="Historial" @OnBottom="LoadHistory(true)" class="pa-body">
        <div class="" v-if="history.length > 0">
            <div class="section mb10 selectable" 
            v-for="(transaction, index) in history"
            :key="index"
            @click="$refs.expenseDetails.Open(transaction)">
                <div class="flex fill align-center">
                    <avatar class="mr10"
                    defaultImageIcon="1727"
                    :imageIcon="transaction.type"">
                    </avatar>
                    <div class="flex-fill flex column">
                        <div class="bold">{{transaction.type}}</div>
                        <div class="secondary-text" v-if="transaction.comment"><span class="bold">Comentario:</span> {{transaction.comment}}</div>
                        <div class="secondary-text" v-if="transaction.custom_data && transaction.custom_data.created_by"><span class="bold">Ingresado por:</span> {{transaction.custom_data.created_by}}</div>
                        <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                        <div class="secondary-text cred" v-if="transaction.deleted_at"><span class="bold">Eliminado:</span> {{Util.Date(transaction.deleted_at, 'DD/MM/YYYY HH:mm')}} por {{transaction.custom_data.deleted_by}}</div>
                        <div class="secondary-text cyellow" v-if="transaction.updated_at"><span class="bold">Editado:</span> {{Util.Date(transaction.updated_at, 'DD/MM/YYYY HH:mm')}} por {{ transaction.custom_data.updated_by }}</div>
                        <div class="secondary-text cyellow" v-if="!transaction.expense_turn" title="No se muestra en reportes de Turno"><span class="bold"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</span></div>
                    </div>
                    <div class="flex column ta-right unshrink">
                        <div :class="transaction.deleted_at ? 'line-through' : 'bold'">{{Util.Price(transaction.money)}}</div>
                        <div class="secondary-text">{{Util.PayMethod(transaction.pay_method)}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
    </vertical-content>

    <div slot="Cuenta de Gastos" class="pa-body">
        <div class="secondary-text ta-center mt10" v-if="!filtered.length">No hay datos</div>
        <div class="" v-if="filtered.length">
            <div class="section mb10 selectable"
            v-for="(expense, index) in filtered"
            :key="index"
            @click="isAdmin ? Summary(expense) : OpenModalAdd(expense)">
                <div class="fill flex align-center">

                    <avatar class="mr10"
                    defaultImageIcon="1727"
                    :imageIcon="expense.title">
                    </avatar>

                    <div class="flex-fill flex column">
                        <div class="bold">{{expense.title}}</div>
                        <div v-if="expense.category" class="secondary-text">Categoría - {{DictCategories[expense.category]? DictCategories[expense.category] : expense.category}}</div>
                        <div v-if="expense.description" class="secondary-text">{{expense.description}}</div>
                        <div v-if="expense.auto" class="secondary-text">Gasto automático de {{Util.Price(expense.auto_money)}} a {{expenseEvent[expense.auto]}}</div>
                    </div>
                    <div class="flex column" style="text-align: right">
                        <div>
                            <span class="bold ta-center mr10">{{Util.Price(expense.total_date ? expense.total_date : 0)}}</span>
                        </div>
                    </div>
                    <div v-if="isAdmin" class="options icon-dots-vertical" @click.stop="Options([
                        {text: 'Eliminar', class: 'error-color', function: () => {DeleteExpense(expense.title)}, confirm: '¿Eliminar cuenta de gasto definitivamente?', icon: 'trash'},
                        {text: 'Editar', function: () => {modalNew = {edit: true, oldTitle: expense.title, expense: Util.Copy(expense, {auto_event: expense.auto})}}, icon: 'edit'}, //TODO
                        {text: 'Ingresar Gasto', class: 'selected-color', function: () => OpenModalAdd(expense), icon: 'square-plus' },
                    ])"></div>
                </div>
            </div>
        </div>

    </div>

    <provider-list
    slot="Proveedores"
    ref="providerList"
    :view="'EXPENSES'"
    :expenses="expenses"
    :payMethods="methods"
    :search="searchProvider"
    @LoadExpenses="LoadExpenses"
    @LoadHistory="LoadHistory"
    @Search="Search"
    @LoadProviders="LoadProviders"
    ></provider-list>
</tabs>

<modal v-model="modalNew" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="modalNew ? (modalNew.oldTitle ? `Editar ${modalNew.oldTitle}` : 'Nueva Cuenta de Gasto') : ''">
    <div class="section" v-if="modalNew">
        <input-field class="mb15"
        v-model="modalNew.expense.title"
        label="Título">
        </input-field>

        <input-field class="mb15"
        v-model="modalNew.expense.description"
        label="Descripción">
        </input-field>

        <input-select class="mb15"
        v-model="modalNew.expense.category"
        label="Categoría"
        placeholder="Sin categoría"
        :items="[
            {text: 'Gastos Operacionales', value: 'operational_expenses'}, 
            {text: 'Gastos Administrativos', value: 'administrative_expenses'}
        ]"
        canType>
        </input-select>

        <label class="">
            <input type="checkbox" v-model="modalNew.expense.auto"> Ingresar gasto automáticamente <div class="checkmark"></div>
        </label>

        <input-select class="mt15"
        v-if="modalNew.expense.auto"
        v-model="modalNew.expense.auto_event"
        label="Periodo"        
        :items="[{text: 'Fin de Mes', value: 'END_OF_MONTH'}, 
                {text: 'Inicio de Mes', value: 'START_OF_MONTH'},
                {text: 'Fin de Semana', value: 'END_OF_WEEK'},
                {text: 'Inicio de Semana', value: 'START_OF_WEEK'}]">
        </input-select>

        <input-field class="mt15"
        v-if="modalNew.expense.auto"
        v-model="modalNew.expense.auto_money"
        label="Cantidad"
        prefix="$"
        type="int+">
        </input-field>

    </div>
    
    <button slot="actions" class="primary purple" @click="SaveExpense()">Aceptar</button>
    
</modal>

<!-- ---- MODAL PARA CONFIRMACION DE IMPRESION ---- -->
<modal v-model="modalConfirm.show" modalClass="md">
    <div class="pa20">
        <div v-if="modalConfirm.show" class="ta-center mb10" v-html="modalConfirm.title"></div>
        <div class="flex justify-center">
            <label>
                <input type="checkbox" v-model="modalConfirm.tempDoNotShowAgain">No volver a mostrar<div class="checkmark"></div>
            </label>
        </div> 
    </div>

    <button slot="actions"  @click="modalConfirm.show = false;" class="secondary">Cancelar</button>
    <button slot="actions" class="primary" @click="PrintExpenseVoucher()">Imprimir</button>
</modal>

<modal v-model="modalAdd" :dir="['right', 'center']" :modalClass="['fill', 'sm']" :title="(modalAdd && !modalAdd.id ? 'Ingresar ' : 'Editar ') + `Gasto de ${modalAdd ? modalAdd.type : ''}`">
    <div class="section" v-if="modalAdd">

        <input-select
        v-if="modalAdd && modalAdd.id"
        v-model="modalAdd.type" 
        :items="typesSelectItems" 
        canType="search"
        label="Cuenta de Gasto"
        class="mb15">
        </input-select>

        <input-select
        ref="selectProvider"
        v-model="modalAdd.provider" 
        :items="providersItems" 
        canType="search"
        label="Proveedor"
        class="mb15">
        </input-select>

        <input-date
        v-if="modalAdd.add_date && (Auth.role.indexOf('admin') > -1 || (Auth.role == 'cashier' && Auth.restrictions.can_add_past_expenses))"
        v-model="modalAdd.date"
        label="Fecha de Gasto"
        format="timestamp"
        class="mb15"
        >
        </input-date>

        <label slot="actions" style="flex: auto" class="mb15" v-if="Auth.role.indexOf('admin') > -1 || (Auth.role == 'cashier' && Auth.restrictions.can_add_past_expenses)">
            <input type="checkbox" v-model="modalAdd.add_date"> Ingresar otra fecha<div class="checkmark"></div>
        </label>

        <input-field class="mb15"
        v-model="modalAdd.money"
        label="Total"
        type="number">
        </input-field>

        <input-select class="mb15"
        v-model="modalAdd.pay_method"
        :items="methods"
        label="Método de Pago">
        </input-select>

        <input-field class="mb15"
        v-model="modalAdd.comment"
        label="Comentario"
        placeholder="(Opcional)">
        </input-field>

        <!--<input-image v-model="modalAdd.image" label="Documento (Opcional)"></input-image>-->
        <input-files v-model="modalAdd.files" label="Documento (Opcional)"></input-files>

    </div>
    
    <label slot="actions" class="flex align-center" style="flex: auto" v-if="canExpenseTurn && modalAdd">
        <input type="checkbox" v-model="modalAdd.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
    </label>
    <button slot="actions" class="primary purple" @click="Expense()">Aceptar</button>
    
</modal>

<modal v-model="modalTypeSummary" dir="right" :title="modalTypeSummary?modalTypeSummary.title:''" :modalClass="['fill', 'md right h100']" hideActions>
    <input-date :icon="mobile ? 'calendar' : null"
        v-show="tabModal == 'Historial'"
        slot="options"
        inputClass="secondary" 
        type="DATE"
        format="timestamp"
        v-model="dateFilterOnModal"
        modalOnly
        :toEndDay="true"
        @OnAcceptDate="LoadTypeHistory()">
    </input-date>
    <input-range inputClass="secondary"
    v-show="tabModal == 'Resumen'"
    class="ml5"
    slot="options"
    v-model="rangeResume"
    :icon="mobile ? 'calendar' : ''"
    :triggerFirstValueChanged="false"
    @OnValueChanged="Summary(modalTypeSummary)">
    </input-range>
    <tabs v-if="modalTypeSummary" :tabs="itemTabs" :keyByTab="true" @OnTabHistorial="modalTypeSummary.history.length == 0 ? LoadTypeHistory() : null" v-model="tabModal">
        <div slot="Resumen">
            <div class="secondary-text mt10 ta-center" v-if="!modalTypeSummary.stats">No hay datos.</div>
            <div class="section" v-if="modalTypeSummary.stats">

                <div class="flex mb15">
                    <div class="flex-fill">
                        <div class="bold">Transacciones</div>
                        <div>{{Util.Number(modalTypeSummary.stats.count)}}</div>
                    </div>
                    <button class="secondary" @click="$refs.transactionExpenseList.Open(modalTypeSummary.stats.transactions)">Ver Transacciones</button>
                </div>
                <div class="mb15">
                    <div class="bold">Total gastado</div>
                    <div>{{Util.Price(modalTypeSummary.stats.total_money)}}</div>
                </div>
                <div class="mb15">
                    <div class="bold">Promedio gastado por semana</div>
                    <div>{{Util.Price(Math.round(modalTypeSummary.stats.total_money/4))}}</div>
                </div>
                <div class="">
                    <div class="bold">Promedio gastado por día</div>
                    <div>{{Util.Price(Math.round(modalTypeSummary.stats.total_money/30))}}</div>
                </div>
            </div>
        </div>
        <vertical-content ref="verticalTypeHistory" slot="Historial" @OnBottom="LoadTypeHistory(true)" class="pa20" >
            <div class="" v-if="modalTypeSummary.history.length > 0">
                <div class="entry selectable" 
                v-for="(transaction, index) in modalTypeSummary.history"
                :key="index"
                @click="$refs.expenseDetails.Open(transaction)">
                    <div class="flex fill align-center">
                        <div class="flex-fill flex column">
                            <div class="bold">{{transaction.type}}</div>
                            <div class="secondary-text" v-if="transaction.comment"><span class="bold">Comentario:</span> {{transaction.comment}}</div>
                            <div class="secondary-text" v-if="transaction.custom_data && transaction.custom_data.created_by"><span class="bold">Ingresado por:</span> {{transaction.custom_data.created_by}}</div>
                            <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text cred" v-if="transaction.deleted_at"><span class="bold">Eliminado:</span> {{Util.Date(transaction.deleted_at, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text cyellow" v-if="transaction.updated_at"><span class="bold">Editado:</span> {{Util.Date(transaction.updated_at, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text cyellow" v-if="!transaction.expense_turn" title="No se muestra en reportes de Turno"><span class="bold"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</span></div>
                        </div>
                        <div :class="transaction.deleted_at ? 'line-through' : 'bold'">{{Util.Price(transaction.money)}}</div>
                        <!--<i class="icon icon-arrow-right-o c4 ml10"></i>-->
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
        </vertical-content>
    </tabs>
</modal>

<expense-details ref="expenseDetails" @OnTransactionDeleted="OnTransactionDeleted" @OnTransactionExpenseEdited="OnTransactionExpenseEdited($event)"></expense-details>
<expenses-transactions-list ref="transactionExpenseList"  @OnTransactionDeleted="OnTransactionDeleted"></expenses-transactions-list>
</div>
</template>

<script>
import moment from 'moment';
export default {
    data() {
        return {
            tab: null,
            tabModal : null,
            modalNew: null,
            modalAdd: null,
            modalTypeSummary: null,
            expenses: [],
            dateFilter : null,
            dateFilterOnModal: null,
            history: [],
            historyPage: 0,
            stats: null,
            rangeResume: null,
            range: {
                option: 'MONTH',
                index: 0
            },
            methods: [{text: 'Sin definir', value: 'UNDEFINED'}],
            search: '',
            expenseEvent: {
                START_OF_MONTH: 'inicio de mes',
                END_OF_MONTH: 'fin de mes',
                START_OF_WEEK: 'inicio de la semana (lunes)',
                END_OF_WEEK: 'fin de la semana (domingos)',
            },
            DictCategories: {
                operational_expenses: 'Gastos Operacionales',
                administrative_expenses: 'Gastos Administrativos'
            },
            tabs: null,
            itemTabs: null,
            modalConfirm : { show : false, doNotShowAgain : false, tempDoNotShowAgain: false },
            providers : null,
            searchProvider : '',
            rangeExpenses : null
        }
    },
    mounted() {

        this.tabs = [];
        if(this.Local.modules.module_expenses) this.tabs.push('Cuenta de Gastos');
        if(this.canCreateProvider || this.canPayInvoices || this.canCreateInvoices || this.canEditProvider)
            if(this.Local.modules.module_inventory) this.tabs.push('Proveedores');
        if(this.Local.modules.module_expenses && this.isAdmin) this.tabs.push('Resumen', 'Historial');

        this.itemTabs = [];
        if(this.Local.modules.module_expenses) this.itemTabs.push('Resumen', 'Historial');

        if(this.tabs[0] == 'Cuenta de Gastos') this.LoadExpenses();
    },
    methods: {
        Search()
        {
            if(!this.isAdmin) return;

            this.Loading();
            axios.post(`/expenses/${this.Local.id}/stats`, this.range).then(res => {
                this.Response(res);

                var count = 0;
                res.data.types.forEach(type => {
                    count += type.count;
                });
                res.data.count = count;

                this.stats = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        SaveExpense() {
            var expense = this.modalNew.expense;
            if(!expense.title) return this.$root.$emit('Response', {info: 'Título inválido.'});
            if(expense.auto && !expense.auto_money) return this.$root.$emit('Response', {info: 'Datos inválidos.'});
            
            expense.title = expense.title.toUpperCase();
            if(this.modalNew.edit)
            {
                var func = () => {
                    this.Loading();
                    axios.patch(`/expense/${this.Local.id}`, {expense: expense, oldTitle: this.modalNew.oldTitle}).then(res => {
                        this.Response(res);
                        this.expenses = res.data;
                        this.modalNew = false;
                    }).catch(err => {
                        this.Response(err);
                    });
                }

                if(expense.title !== this.modalNew.oldTitle)
                {
                    this.Confirm({
                        text: 'Cambiar',
                        title: '¿Cambiar el nombre de la cuenta de gasto? No se cambiarán los gastos previamente ingresados',
                        function: () => {func()}
                    });
                }
                else
                {
                    func();
                }

                
            }
            else
            {
                this.Loading();
                axios.put(`/expense/${this.Local.id}`, {expense: expense}).then(res => {
                    this.Response(res);
                    this.expenses = res.data;
                    this.modalNew = false;
                }).catch(err => {
                    this.Response(err);
                });
            }
        },
        DeleteExpense(type) {
            this.Loading();
            axios.post(`/expense/${this.Local.id}/type`, {title: type}).then(res => {
                this.Response(res);
                this.expenses = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        Expense() {
            if(!this.modalAdd.money) return this.Info('Datos inválidos.');
            if(this.Auth.restrictions && this.Auth.restrictions.required_payment_methods && this.modalAdd.pay_method == 'UNDEFINED') return this.Info('Debe seleccionar un método de pago.');
            this.Loading();
            
            if(!this.modalAdd.add_date) this.modalAdd.date = null;            

            //editar gasto
            if(this.modalAdd.id)
            {
                axios.patch(`/expense/transaction/${this.Local.id}`, this.modalAdd).then(res => {
                    // this.modalConfirm.data = this.modalAdd;
                    this.modalConfirm.data = res.data;
                    this.CheckPrintConfirm();
                    this.history = this.history.map(entry => entry.id === res.data.id ? res.data : entry);
                    this.modalAdd = null;
                    this.$refs.expenseDetails.expense = null;
                    this.stats = null;
                    this.LoadExpenses();
                    this.Response(res);
                }).catch(err => {
                    this.Response(err);
                });
                return;
            }
            
            axios.post(`/expense/${this.Local.id}`, this.modalAdd).then(res => {
                this.modalConfirm.data = this.modalAdd
                this.CheckPrintConfirm();
                this.modalAdd = null;
                this.history = [];
                this.stats = null;
                this.LoadExpenses();
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        Summary(expense=null)
        {
            if(!this.rangeResume) this.SetRange();
            this.Loading();
            axios.post(`/expense/${this.Local.id}/${expense.title}/summary`, this.rangeResume).then(res => {
                this.Response(res);
                this.modalTypeSummary = {title: expense.title};
                this.modalTypeSummary.stats = res.data;
                this.modalTypeSummary.history = [];
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadTypeHistory(bottom=false)
        {
            if(!bottom) 
            {
                this.modalTypeSummary.history = [];
                this.modalTypeSummary.historyPage = 0;
                this.$refs.verticalTypeHistory.Reset();
            }
            if(bottom && !this.modalTypeSummary.history.length) return;
            this.Loading();
            this.$nextTick(() => {
                axios.get(`/expense/${this.Local.id}/history/type/${this.modalTypeSummary.title}/${this.dateFilterOnModal}?page=${++this.modalTypeSummary.historyPage}`).then(res => {
                    this.Response(res);
                    this.modalTypeSummary.history = this.modalTypeSummary.history.concat(res.data.data);
                    this.$forceUpdate();
                }).catch(err => {
                    this.Response(err);
                });
            })
        },
        LoadHistory(bottom=false)
        {
            if(!bottom) 
            {
                this.history = [];
                this.historyPage = 0;
                this.$refs.verticalHistory.Reset()
            }
            if(bottom && !this.history.length) return;
            this.Loading();
            this.$nextTick(() => {
                axios.get(`/expenses/${this.Local.id}/history/${this.dateFilter}?page=${++this.historyPage}`).then(res => {
                    this.Response(res);
                    this.history = this.history.concat(res.data.data);
                }).catch(err => {
                    this.Response(err);
                }); 
            })
        },
        async LoadExpenses()
        {
            this.Loading();
            await axios.get(`/expenses/${this.Local.id}?rangeStart=${this.rangeExpenses.rangeStart}&rangeEnd=${this.rangeExpenses.rangeEnd}`).then(res => {
                this.methods = [{text: 'Sin definir', value: 'UNDEFINED'}];
                this.Response(res);
                this.expenses = res.data.types;
                for(var i = 0; i < res.data.pay_methods.length; i++)
                    this.methods.push({text: res.data.pay_methods[i] == 'CASH' ? 'Efectivo' : res.data.pay_methods[i], value: res.data.pay_methods[i]});
            }).catch(err => {
                this.Response(err);
            });
        },
        Export(){
            this.Loading();
            axios.post(`/expenses/${this.Local.id}/export`, this.range, {responseType: 'blob'})
            .then(res => {
                    this.Response(res);
                    this.Util.DownloadFile(res, `gastos_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });
        },
        OnTransactionDeleted(transaction) {
            if(this.$refs.transactionExpenseList && this.$refs.transactionExpenseList.modal){
                this.Search();
            }else {
                this.history = this.history.map(entry => entry.id === transaction.id ? transaction : entry);
                this.stats = null;
            }
        },
        CheckPrintConfirm(){
            if(this.modalConfirm.doNotShowAgain) {
                this.PrintExpenseVoucher()
                return 
            }
            this.modalConfirm.tempDoNotShowAgain = this.modalConfirm.doNotShowAgain
            this.modalConfirm.show = true
            this.modalConfirm.title = '¿Imprimir voucher de ingreso de gasto?'
        },
        PrintExpenseVoucher(){
            if(!this.modalConfirm.data) return
            this.modalConfirm.doNotShowAgain = this.modalConfirm.tempDoNotShowAgain;
            var now = moment();
            let provider = this.modalConfirm.data.custom_data && this.modalConfirm.data.custom_data.provider ? this.modalConfirm.data.custom_data.provider : this.modalConfirm.data.provider;
            const voucherPrintArr = [
                { text: this.modalConfirm.data.type },
                { text: `Fecha de impresión: ${now.format("HH:mm DD/MM/YYYY")}` },
                { text: `Fecha del gasto: ${this.Util.Date(this.modalConfirm.data.date,'HH:mm DD/MM/YYYY')}` },
                { text: `Ingresado por: ${this.Auth.name}`}];

                if(this.modalConfirm.data.updated_at) voucherPrintArr.push(
                    { text: `Editado por: ${this.modalConfirm.data.custom_data.updated_by}` }, 
                    { text: `Fecha edición: ${this.Util.Date(this.modalConfirm.data.updated_at,'HH:mm DD/MM/YYYY')}`}
                );

                if(provider && provider.name) voucherPrintArr.push(
                    { text: `Proveedor: ${provider.name} ${provider.rut && (provider.has_rut == undefined || provider.has_rut) ? `- (${provider.rut})` : ''}` }, 
                );

                if(this.modalConfirm.data.comment) {
                    voucherPrintArr.push({ line: true });
                    voucherPrintArr.push({ text: `Comentario: ${this.modalConfirm.data.comment}` });
                }
                voucherPrintArr.push(
                    { line: true },
                    { text: `Método de pago: ${this.Util.PayMethod(this.modalConfirm.data.pay_method)}` },
                    { text: `Total: $${this.Util.Number(this.modalConfirm.data.money)}` }
                );
            this.Util.NotifyService('print', {data: voucherPrintArr, id: Math.random().toString()});
            this.modalConfirm.show = false;
            this.modalConfirm.data = null
        },
        async LoadProviders()
        {
            if (!this.canCreateProvider && !this.canPayInvoices && !this.canCreateInvoices && !this.canEditProvider) return;
            await axios.get(`/providers/${this.Local.id}/v2${'?view=EXPENSES'}`).then(res => {
                this.Response(res);
                this.$refs.providerList.providers = res.data.providers
                this.$refs.providerList.pendingInvoices = res.data.counts;
                this.providers = res.data.providers;
                this.pendingInvoices = res.data.counts;
                // this.$emit('SetProviders',this.providers);
            }).catch(err => {
                this.Response(err);
            });

            if(!this.expenses.length) await this.LoadExpenses();
        },
        OpenModalAdd(expense)
        {
            if(!this.providers) this.LoadProviders();
            let expenseTurn = true;
            if (this.canExpenseTurn) {
                expenseTurn = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expenseTurn == null) expenseTurn = true;
            }
            this.modalAdd={type: expense.title, expense_turn: expenseTurn, provider: null, add_date: false};
        },
        SetRange() {
            this.rangeResume = {
                option: 'MONTH',
                index: 0,
                label: 'Este mes',
                rangeStart: moment().startOf('month').unix(),
                rangeEnd: moment().endOf('month').unix(),
            };
        },
        async OnTransactionExpenseEdited(expense) {
            let copyExpense = this.Util.Copy(expense);
            
            if (!this.providers) await this.LoadProviders();
            this.modalAdd = copyExpense;

            let itemFound = this.providersItems.find(item => {
                if(item.value && this.modalAdd.provider && this.modalAdd.provider.rut) return item.value.rut === this.modalAdd.provider.rut;
            });
            
            this.$set(this.modalAdd, 'provider', itemFound ? itemFound.value : null);
        }
        
    },
    watch: {
        'modalAdd.expense_turn'(val) {
                if (!this.modalAdd) return;
                if (!this.canExpenseTurn) return;
                localStorage.setItem('expenseTurn', !!val);
        },
        modalTypeSummary: {
            handler(newVal) {
                if (!newVal) this.rangeResume = null;
            },
        }
    },
    computed: {
        filtered() {
            if(!this.expenses) return [];
            if(!this.search) return this.expenses;
            var ret = [];
            for(var i = 0; i < this.expenses.length; i++)
                if(this.expenses[i].title.toUpperCase().indexOf(this.search.toUpperCase()) > -1) ret.push(this.expenses[i]);
            
            return ret;
        },
        inventorySelectItems() {
            var ret = [];
            for(var key in this.expenses)
            {
                var item = this.expenses[key];
                ret.push({
                    text: item.title,
                    value: item.title
                });
            }
            return this.Util.NaturalSort(ret, 'text');
        },
        tabCount() {
            return {
                Cuentas: this.expenses ? this.expenses.length : 0,
                Proveedores: this.providers ? Object.values(this.providers).length : 0
            }
        },
        canCreateProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_providers);
        },
        canCreateInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_inventory_invoices);
        },
        canPayInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.pay_pending_inventory_invoices);
        },
        canEditProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_providers);
        },
        typesSelectItems() {
            var ret = [];
            for(var key in this.expenses)
            {
                var item = this.expenses[key];
                ret.push({
                    text: item.title,
                    value: item.title
                });
            }
            return this.Util.NaturalSort(ret, 'text');
        },
        providersItems() {
            var ret = [{text: 'Sin proveedor', value: null}];
            if(!this.providers) return ret;
            for(var key in this.providers)
            {
                var name = this.providers[key].name;
                var has_rut = this.providers[key].has_rut;
                ret.push({text: `${name} ${!has_rut? '' : '- '+key}`, value: {rut: key, name: name, has_rut : has_rut}});
            }
            return ret;
        },
        canExpenseTurn() {
            return this.Turn && (this.Auth.role.indexOf('admin') > -1 || (this.Auth.restrictions && this.Auth.restrictions.enable_expense_turn));
        }
    },
}
</script>